import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=1b0aaa3c&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=1b0aaa3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0aaa3c",
  null
  
)

export default component.exports